import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'translateDate',
    pure: false,
    standalone: true,
})
export class TranslateDatePipe implements PipeTransform {
	private value: string | null;

	constructor(private translate: TranslateService) {}

	transform(date: any, pattern: string = 'mediumDate'): any {
		const currentLang = this.translate.currentLang;

		if (date) {
			let newDate = new Date(date);

			if (newDate.getFullYear() > 1) {
				if (pattern === 'hours') {
					this.value = new DatePipe(currentLang).transform(
						newDate,
						'HH:mm'
					);
				} else {
					this.value = new DatePipe(currentLang).transform(
						newDate,
						pattern
					);
				}

				return this.value;
			} else {
				return '';
			}
		} else {
			return '';
		}
	}
}
